import { QuestionRepeatType } from "consts";

const QuestionRepeatTypeOptions = [
  { type: "Never", value: QuestionRepeatType.Never },
  { type: "Immediately", value: QuestionRepeatType.Immediately },
  { type: "After a specific number of days", value: QuestionRepeatType.After },
];

export default QuestionRepeatTypeOptions;
